import { useState } from 'react'
import { usePermission } from '@/features/auth/store'
import { OverrideStageDialog } from './OverrideStageDialog'

type Props = {
  contractId: number
  configurationCode: string
  currentStageCode: string
}

/**
 * Przycisk "Zmień etap" -- widoczny tylko dla użytkowników z
 * {@code contracts.contract.stage_override}. Klik otwiera dialog, w którym admin wybiera
 * dowolny etap produktu (z pominięciem warunków bramy) i podaje powód do audytu.
 */
export function OverrideStageButton({ contractId, configurationCode, currentStageCode }: Props) {
  const canOverride = usePermission('contracts.contract.stage_override')
  const [open, setOpen] = useState(false)
  if (!canOverride) return null
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="w-full rounded border border-slate-400 text-slate-700 px-2 py-1 text-xs hover:bg-slate-100"
      >
        Zmień etap (admin)
      </button>
      <OverrideStageDialog
        contractId={contractId}
        configurationCode={configurationCode}
        currentStageCode={currentStageCode}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  )
}
